<script>
import Vue from "vue";
export default {
  data() {
    return {};
  },
  render(createEl) {
    const imgCtorl = createEl("el-image", {
      style: { position: "fixed", left: "-99999px", "z-index": 99999 },
      class:"global-img"
    });
    Vue.prototype.$global_img = imgCtorl;
    imgCtorl.previewSC=(src="",arr=[],scale=1)=>{
      console.log(imgCtorl)
      //图片 放大方法
      imgCtorl.componentInstance.previewSrcList=arr;
      imgCtorl.componentInstance.src=src;
      imgCtorl.componentInstance.clickHandler();
      this.$nextTick(()=>{
        imgCtorl.componentInstance.$children[0].transform.scale=scale;
        let hidefunc=imgCtorl.componentInstance.$children[0].hide;
          imgCtorl.componentInstance.$children[0].hide=(...rag)=>{
            console.log("关闭")
            setTimeout(()=>{document.body.style=""},100)
            return hidefunc(...rag);
          }
      })
    }
    
    console.log(
      `%cglobal-img组件挂载`,
      "background: linear-gradient(172deg, red, blue,purple);font-size:30px;"
    );
    return imgCtorl;
  },
};
</script>

<style >
.global-img .el-icon-circle-close{
  color: #fff;
}
</style>